import { render, staticRenderFns } from "./payCenterEdit.vue?vue&type=template&id=322cc962&scoped=true"
import script from "./payCenterEdit.vue?vue&type=script&lang=js"
export * from "./payCenterEdit.vue?vue&type=script&lang=js"
import style0 from "./payCenterEdit.vue?vue&type=style&index=0&id=322cc962&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322cc962",
  null
  
)

export default component.exports